export default "__VITE_ASSET__31040b3a__"